/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfBoolean } from "../models/AjaxResponseOfBoolean";
import type { AjaxResponseOfCommercePaywallDto } from "../models/AjaxResponseOfCommercePaywallDto";
import type { AjaxResponseOfCommerceSubscriptionsDto } from "../models/AjaxResponseOfCommerceSubscriptionsDto";
import type { AjaxResponseOfListOfCommerceProductDto } from "../models/AjaxResponseOfListOfCommerceProductDto";
import type { AjaxResponseOfProductPlanChangePreview } from "../models/AjaxResponseOfProductPlanChangePreview";
import type { AjaxResponseOfProductPlanChangeResult } from "../models/AjaxResponseOfProductPlanChangeResult";
import type { AjaxResponseOfProductSubscriptionDto } from "../models/AjaxResponseOfProductSubscriptionDto";
import type { CancelPendingCommercePlanChangeInput } from "../models/CancelPendingCommercePlanChangeInput";
import type { ChangeCommercePlanInput } from "../models/ChangeCommercePlanInput";
import type { PreviewCommercePlanChangeInput } from "../models/PreviewCommercePlanChangeInput";
import type { StartCommerceTrialInput } from "../models/StartCommerceTrialInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class CommerceAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfCommercePaywallDto Success
   * @throws ApiError
   */
  public getPaywall({
    productCode,
    metricCode,
    requestedDelta,
    operationId,
  }: {
    productCode: string;
    metricCode: string;
    requestedDelta?: number;
    operationId?: string;
  }): CancelablePromise<AjaxResponseOfCommercePaywallDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/commerce/paywall",
      query: {
        productCode: productCode,
        metricCode: metricCode,
        requestedDelta: requestedDelta,
        operationId: operationId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanChangeResult Success
   * @throws ApiError
   */
  public changePlan({
    requestBody,
  }: {
    requestBody?: ChangeCommercePlanInput;
  }): CancelablePromise<AjaxResponseOfProductPlanChangeResult> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/commerce/plan-change",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        409: `Conflict`,
      },
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanChangeResult Success
   * @throws ApiError
   */
  public cancelPendingPlanChange({
    requestBody,
  }: {
    requestBody?: CancelPendingCommercePlanChangeInput;
  }): CancelablePromise<AjaxResponseOfProductPlanChangeResult> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/commerce/plan-change/cancel-pending",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfProductPlanChangePreview Success
   * @throws ApiError
   */
  public previewPlanChange({
    requestBody,
  }: {
    requestBody?: PreviewCommercePlanChangeInput;
  }): CancelablePromise<AjaxResponseOfProductPlanChangePreview> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/commerce/plan-change/preview",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfCommerceProductDto Success
   * @throws ApiError
   */
  public getProducts(): CancelablePromise<AjaxResponseOfListOfCommerceProductDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/commerce/products",
    });
  }
  /**
   * @returns AjaxResponseOfCommerceSubscriptionsDto Success
   * @throws ApiError
   */
  public getSubscriptions(): CancelablePromise<AjaxResponseOfCommerceSubscriptionsDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/commerce/subscriptions",
    });
  }
  /**
   * @returns AjaxResponseOfProductSubscriptionDto Success
   * @throws ApiError
   */
  public startTrial({
    requestBody,
  }: {
    requestBody?: StartCommerceTrialInput;
  }): CancelablePromise<AjaxResponseOfProductSubscriptionDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/commerce/trials",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfBoolean Success
   * @throws ApiError
   */
  public synchronizeProductAccess(): CancelablePromise<AjaxResponseOfBoolean> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/commerce/product-access/synchronize",
    });
  }
}
